import { render, staticRenderFns } from "./add-bulletin.vue?vue&type=template&id=2addc014&scoped=true"
import script from "./add-bulletin.vue?vue&type=script&lang=ts"
export * from "./add-bulletin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2addc014",
  null
  
)

export default component.exports